import React, {Component} from 'react';
import Modal from 'react-modal';
import {BOUNDS, LOC_NAME, PUBLIC } from "../../constants/Game";
import {fetchGame, deleteGame, updateGame} from "../../actions";
import {minLength2, required} from "../../constants/ValidationRules";
import withAuthorization from "../auth/withAuthorization";
import {withRouter} from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import SetMapBounds from "../huntcomponents/UpdateBoundsOnMap";
import windowSize from 'react-window-size';
import {renderField, WizardHeader} from "../common_page_elements";

import '../../global.css';
import {googleBoundsToFirebaseBounds} from "../../helper_functions";
import {ConfirmDelete} from "../huntcomponents/dialogs";
import {compose} from "recompose";
import {possessiveNameFromUser} from "../yourpage/HomePage";

class WizardLocation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            timeoutPending: null,
            userLocation: null,
            findingLocation: "Finding your location...",
            deleteConfirmIsOpen: false,
            // a google.maps.Rectangle
            boundsRect: null
        };

        this.onNext = this.onNext.bind(this);
        this.delete = this.delete.bind(this);
        this.setUserLocation = this.setUserLocation.bind(this);
        this.determineUserLocation = this.determineUserLocation.bind(this);
        this.locationNo = this.locationNo.bind(this);
        this.setBoundsRect = this.setBoundsRect.bind(this);
        this.openDeleteModal = this.openDeleteModal.bind(this);
        this.closeDeleteModal = this.closeDeleteModal.bind(this);
    }

    componentDidMount () {
        window.scrollTo(0, 150);

       if (this.props.latLon) {
           this.setUserLocation(this.props.latLon)
        } else {
           const num = window.setTimeout(this.determineUserLocation, 2000);
           this.setState( { timeoutPending: num });
        }
    }

    componentWillUnmount() {
        if (!!this.state.timeoutPending) {
            window.clearTimeout(this.state.timeoutPending)
        }
    }

    setBoundsRect(rect) {
        this.setState( { boundsRect: rect });
    }

    openDeleteModal(index) {
        this.setState({deleteConfirmIsOpen: true, indexSelected: index});
    }

    closeDeleteModal() {
        this.setState({deleteConfirmIsOpen: false, indexSelected: -1}
        );
    }

    determineUserLocation() {

        if ("geolocation" in navigator) {
            const geo_options = {
                enableHighAccuracy: false,
                maximumAge        : 30000,
                timeout           : 15000
            };
            this.setState( { timeoutPending: null });
            navigator.geolocation.getCurrentPosition(this.setUserLocation, this.locationNo, geo_options);
        } else {
            this.setState( { findingLocation: null });
        }
    }

    setUserLocation(position) {

        this.setState( { userLocation: position.coords, findingLocation: null });
    }

    locationNo(error) {
        switch (error.code) {
            case 1:
                // denied
                this.setState( { findingLocation: null });
                break;
            case 3: // time out
            case 0: // unknown
            case 2: // not available
            default:
                this.setState( { findingLocation: "Could not determine location." });
                console.warn("Error getting location: " + error.message)
        }
    }

    delete() {
        const {id} = this.props.match.params;
        const game = this.props.games[id];

        const isPublic = game.isPublic;

        this.props.deleteGame(id, isPublic, () => {
            this.props.history.push('/games');
        });
    }

    onNext(values) {
        const { updateGame, history } = this.props;

        const rect = this.state.boundsRect;
        if (!rect) {
            alert("A hunt bounds is required.  Your hunt must be someplace - click inside the map to show where.");
            return;
        }

        values[BOUNDS] = googleBoundsToFirebaseBounds(rect.getBounds());

        const isPublic = this.game()[PUBLIC];
        const id = this.gameId();

        // get bounds into valuesm as well, then publish

        updateGame(id, isPublic, values, () => {
            history.push(`/games/${id}/new4`);
        });
    }

    calculateMapDialogDimensions() {
        const minDimensions = {width: 330, height: 240};
        const { windowWidth } = this.props;

       const width = Math.max(windowWidth * 1 / 2, minDimensions.width);
        const height = Math.max(windowWidth * 3 / 10, minDimensions.height);
        return {width, height}
    }

    // helper to grab the id from the URL
    gameId() {
        return this.props.match.params.id;
    }

    // helper to get the game object.
    game() {
        const {games} = this.props;
        return games[this.gameId()];
    }

    render() {
        const { games, handleSubmit } = this.props;

        const id = this.gameId();

        // If we don't have data, fetch it and return
        if (!games || !games[id]) {
            // invalid state for step two of wizard (todo: more invalid states)
            fetchGame(id);
            return <div>Loading... </div>
        }

        // Default Minneapolis
        let lat = 44.9;
        let lon = -93.5;
        let hasLocReading = false;

        if (!!this.state.userLocation) {
            lat = this.state.userLocation.latitude;
            lon = this.state.userLocation.longitude;
            if (!!lat && !!lon) {
                hasLocReading = true;
            }
        }

        const game = this.game();
        const { bounding_box } = game;
        const dialogDims = this.calculateMapDialogDimensions();

        const explanation = "Tell the user where this hunt is located.  The treasure hunt bounds is the area where all "
            + "your hunt clues and treasure are located.";

        return (
           <div className='editor'>

               <WizardHeader
                  game={this.game()}
                  backOutText="Cancel"
                  backOutAction={this.openDeleteModal}
                  index={1}
                  stepName="Step 2:  Where is this Hunt?"
                  stepExplanation={explanation}
               />

               {!!this.state.findingLocation &&
                  <p className="red bottom-margin"> {this.state.findingLocation} </p>
               }

               <div className="big-bottom-margin">

                   <SetMapBounds
                      bounds={bounding_box}
                      latDefault={lat}
                      lonDefault={lon}
                      height={dialogDims.height}
                      width={dialogDims.width}
                      hasDefaultLatLon={hasLocReading}
                      allowClear={true}
                      zoomInOnSelection={true}
                      title="Treasure Hunt Bounds"
                      boundsRectCallback={(rect) => {
                          this.setState({boundsRect: rect});
                      }}
                   />
               </div>

               <p className="secondary-text big-top-margin bottom-margin">
                   Also, name or briefly describe where your hunt is located.
               </p>

               <form className="big-bottom-margin" onSubmit={handleSubmit(this.onNext)}>

                   <Field
                      name={LOC_NAME}
                      type="text"
                      component={renderField}
                      label="Location Description"
                      placeholder="E.g. Mulberry Street in Manhattan"
                      validate={[required, minLength2]}
                   />

                   <button type="button" onClick={this.openDeleteModal}
                           className="btn btn-danger right-margin big-top-margin">Cancel
                   </button>
                   <button type="submit" className="btn btn-primary left-margin big-top-margin">Next</button>

               </form>
               <Modal
                  isOpen={this.state.deleteConfirmIsOpen}
                  onRequestClose={this.closeDeleteModal}
                  className="confirm-modal-content"
                  overlayClassName="my-modal-overlay"
               >
                   <ConfirmDelete
                      title="Abandon Hunt"
                      message="Are you sure you want to permanantly delete this new treasure hunt?"
                      confirmText="Yes"
                      onConfirm={this.delete}
                      closeModalCallback={this.closeDeleteModal}
                   />
               </Modal>
           </div>
        )
    }
}

const authCondition = (authUser) => !!authUser;

const mapStateToProps = (state) => {
   const {games, selectedGameId} = state;

   const selectedGame = (games && selectedGameId) ? games[state.selectedGameId] : null;
   const locName = selectedGame ? selectedGame[LOC_NAME] : null;

   const initialValues = selectedGame
      ? {
         [LOC_NAME]: locName ? locName : possessiveNameFromUser(state.userState.user) + " neighborhood",
      }
      : {};

   return {
      authUser: state.sessionState.authUser,
      user: state.userState.user,
      games: state.games,
      latLon: state.latLon,
      initialValues,
      selectedGame
   }
};

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
WizardLocation = reduxForm({
    form: 'NewGame3Form' // a unique identifier for this form
})(
    connect(null, { updateGame }
    )(WizardLocation));

export default compose(
   withAuthorization(authCondition),
   connect(mapStateToProps, { deleteGame }),
   withRouter,
   windowSize
)(WizardLocation);



// WEBPACK FOOTER //
// ./src/components/huntwizard/WizardLocation.js